// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, html {
  overflow: hidden;
  height: 100vh;
  width: 100%;
}

.login-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.login-left-column {
  background: #F8F8F8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;
  overflow: hidden;
}
.image-login{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* overflow: hidden; */
}
.login-left-column img {
  width: 90%;
  height: 90vh;
  border-radius: 36px;
  object-fit: cover;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.login-right-column {
  background: #004996;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 60px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.login-form-wrapper {
  width: 100%;
  max-width: 820px;
  position: relative;
  z-index: 10;
}

.login-header {
  margin-bottom: 60px;
  display: flex;
}
/* .login-header  img{
  width: 60%;
} */
.login-logo {
  font-weight: 800;
  color: white;
  margin: 0;
  letter-spacing: 2px;
}

.login-tagline {
  color: white;
  margin-top: 8px;
  letter-spacing: 3px;
  font-weight: 500;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  position: relative;
  width: 100%;
}

.input-icon {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-40%);
  z-index: 1;
}

.login-input {
  width: 100%;
  padding: 18px 20px 18px 55px;
  border: none;
  border-radius: 8px;
  background: white;
  color: #333;
  outline: none;
  box-sizing: border-box;
  font-family: 'montserrat', sans-serif;
}

.login-input::placeholder {
  color: #004996;
}

.login-input:focus {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}

.forgot-password {
  margin-top: 10px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.forgot-password a {
  color: white;
  text-decoration: none;
  opacity: 0.9;
}

.forgot-password a:hover {
  opacity: 1;
  text-decoration: underline;
}

.login-button {
  width: 90px;
  height: 55px;
  border: none;
  border-radius: 8px;
  background: white;
  color: #1e5ba8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  align-self: flex-end;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.arrow-icon {
  font-weight: bold;
}

/* Circle overlay */

.circleOverlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  opacity: 0.67;
}

.circleOverlay img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* Responsive Design */

@media (max-width: 1024px) {
  .login-container {
    grid-template-columns: 1fr 1fr;
  }

  .login-left-column img {
    max-width: 500px;
  }

  .login-right-column {
    padding: 40px;
  }

  .login-form-wrapper {
    max-width: 600px;
  }

  .login-header {
    margin-bottom: 40px;
  }
}

@media (max-width: 768px) {
  .login-container {
    grid-template-columns: 1fr;
  }

  .login-left-column {
    display: none;
  }

  .login-right-column {
    padding: 30px 20px;
    justify-content: center;
  }

  .login-form-wrapper {
    max-width: 100%;
  }

  .login-header {
    margin-bottom: 40px;
  }

  .login-header img {
    max-width: 200px;
  }

  .login-input {
    padding: 16px 20px 16px 50px;
  }

  .input-icon {
    left: 18px;
  }

  .login-button {
    width: 55px;
    height: 55px;
  }

  .arrow-icon {
  }
}

@media (max-width: 480px) {
  .login-right-column {
    padding: 20px 15px;
  }

  .login-header {
    margin-bottom: 30px;
  }

  .login-header img {
    max-width: 160px;
  }

  .login-form {
    gap: 15px;
  }

  .login-input {
    padding: 14px 15px 14px 45px;
    color: #004996;
  }

  .input-icon {
    left: 15px;
  }

  .forgot-password {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .forgot-password a {
  }

  .login-button {
    width: 50px;
    height: 50px;
    margin-top: 0;
    align-self: flex-start;
  }

  .arrow-icon {
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/login.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;;GAEG;AACH;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,sBAAsB;;AAEtB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;EACA;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;EACA;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;EACA;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody, html {\n  overflow: hidden;\n  height: 100vh;\n  width: 100%;\n}\n\n.login-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n.login-left-column {\n  background: #F8F8F8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n.image-login{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* overflow: hidden; */\n}\n.login-left-column img {\n  width: 90%;\n  height: 90vh;\n  border-radius: 36px;\n  object-fit: cover;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.login-right-column {\n  background: #004996;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 60px;\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.login-form-wrapper {\n  width: 100%;\n  max-width: 820px;\n  position: relative;\n  z-index: 10;\n}\n\n.login-header {\n  margin-bottom: 60px;\n  display: flex;\n}\n/* .login-header  img{\n  width: 60%;\n} */\n.login-logo {\n  font-weight: 800;\n  color: white;\n  margin: 0;\n  letter-spacing: 2px;\n}\n\n.login-tagline {\n  color: white;\n  margin-top: 8px;\n  letter-spacing: 3px;\n  font-weight: 500;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.input-group {\n  position: relative;\n  width: 100%;\n}\n\n.input-icon {\n  position: absolute;\n  left: 20px;\n  top: 50%;\n  transform: translateY(-40%);\n  z-index: 1;\n}\n\n.login-input {\n  width: 100%;\n  padding: 18px 20px 18px 55px;\n  border: none;\n  border-radius: 8px;\n  background: white;\n  color: #333;\n  outline: none;\n  box-sizing: border-box;\n  font-family: 'montserrat', sans-serif;\n}\n\n.login-input::placeholder {\n  color: #004996;\n}\n\n.login-input:focus {\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);\n}\n\n.forgot-password {\n  margin-top: 10px;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.forgot-password a {\n  color: white;\n  text-decoration: none;\n  opacity: 0.9;\n}\n\n.forgot-password a:hover {\n  opacity: 1;\n  text-decoration: underline;\n}\n\n.login-button {\n  width: 90px;\n  height: 55px;\n  border: none;\n  border-radius: 8px;\n  background: white;\n  color: #1e5ba8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n  align-self: flex-end;\n  transition: all 0.3s ease;\n}\n\n.login-button:hover {\n  transform: translateX(5px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.arrow-icon {\n  font-weight: bold;\n}\n\n/* Circle overlay */\n\n.circleOverlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n  opacity: 0.67;\n}\n\n.circleOverlay img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n/* Responsive Design */\n\n@media (max-width: 1024px) {\n  .login-container {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .login-left-column img {\n    max-width: 500px;\n  }\n\n  .login-right-column {\n    padding: 40px;\n  }\n\n  .login-form-wrapper {\n    max-width: 600px;\n  }\n\n  .login-header {\n    margin-bottom: 40px;\n  }\n}\n\n@media (max-width: 768px) {\n  .login-container {\n    grid-template-columns: 1fr;\n  }\n\n  .login-left-column {\n    display: none;\n  }\n\n  .login-right-column {\n    padding: 30px 20px;\n    justify-content: center;\n  }\n\n  .login-form-wrapper {\n    max-width: 100%;\n  }\n\n  .login-header {\n    margin-bottom: 40px;\n  }\n\n  .login-header img {\n    max-width: 200px;\n  }\n\n  .login-input {\n    padding: 16px 20px 16px 50px;\n  }\n\n  .input-icon {\n    left: 18px;\n  }\n\n  .login-button {\n    width: 55px;\n    height: 55px;\n  }\n\n  .arrow-icon {\n  }\n}\n\n@media (max-width: 480px) {\n  .login-right-column {\n    padding: 20px 15px;\n  }\n\n  .login-header {\n    margin-bottom: 30px;\n  }\n\n  .login-header img {\n    max-width: 160px;\n  }\n\n  .login-form {\n    gap: 15px;\n  }\n\n  .login-input {\n    padding: 14px 15px 14px 45px;\n    color: #004996;\n  }\n\n  .input-icon {\n    left: 15px;\n  }\n\n  .forgot-password {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .forgot-password a {\n  }\n\n  .login-button {\n    width: 50px;\n    height: 50px;\n    margin-top: 0;\n    align-self: flex-start;\n  }\n\n  .arrow-icon {\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
